import { FC } from "react";
import { useGetUserFlightsQuery } from "src/store/apis/client";
import { useOrdersList} from "../../../context/OrderListContext";
import OrderCard from "../../OrderCard/OrderCard";
import {SwapIcon} from "src/assets/Icons";
import { NextArrowIcon } from "src/assets/Icons";
import { RootState } from "src/store";
import { useSelector } from "react-redux";
import { STATUS_MAP, UNKNOWN_STATUS } from "../../../constants";
import { FLIGHT_CARD_DATA_MAP, FLIGHT_CARD_ICON } from "./constants";
import Tag from "src/components/Tag/Tag";
import Shell from "src/components/Shell/Shell";
import { PaginationComponent } from "src/components";
import usePaginatedList from "../../../hooks/usePaginatedList";

const Title: FC<{
  origin: string;
  destination: string;
  airline: string;
  isRoundTrip?: boolean;
}> = ({
  origin,
  destination,
  airline,
  isRoundTrip,
}) => {
  return (
    <div className="flex flex-col gap-0.5">
      <div className="flex items-center justify-start gap-2 text-xl">
        <div>{origin}</div>
        <div>{isRoundTrip ? <SwapIcon className="h-4 w-4" /> : <NextArrowIcon className="h-4 w-4" />}</div>
        <div>{destination}</div>
      </div>
      <div className="text-14 font-normal text-font-subtle">{airline}</div>
    </div>
  );
};

export default function FlightsTransactions() {
  const { dateRange } = useOrdersList();
  const clientId = useSelector((state: RootState) => state.client.selectedClientId);
  const { data, isFetching, error } = useGetUserFlightsQuery(
    { dateFrom: dateRange?.[0].locale("en").format("YYYY-MM-DDTHH:mm:ss[Z]"), dateTo: dateRange?.[1].locale("en").format("YYYY-MM-DDTHH:mm:ss[Z]"), clientId },
  );
  const { pageItems, paginationProps } = usePaginatedList(data, `${dateRange?.[0].valueOf()}-${dateRange?.[1].valueOf()}`);

  return (
    <Shell loading={isFetching} error={error} data={data}>
      <div className="flex w-full flex-col gap-4">
        {pageItems?.map((flight) => {
          const status = STATUS_MAP[flight.ticketStatus] ?? UNKNOWN_STATUS;
          const cardData = {
            icon: FLIGHT_CARD_ICON,
            title: <Title origin={flight.origin} destination={flight.destination} airline={flight.airlineName} />,
            tag: <Tag label={status.label} color={status.color} className="rounded-full p-1 px-4 text-sm outline outline-current" />,
            data: flight,
            id: flight.referenceNumber,
          };
          return <OrderCard key={flight.referenceNumber} cardData={cardData} dataMap={FLIGHT_CARD_DATA_MAP} />;
        })}
        <PaginationComponent {...paginationProps} />
      </div>
    </Shell>
  );
}
